export const RenderEditFieldsAutoOrder = [
  {
    id: 'Location',
     label: (
          <span>
            Ship To Location<span style={{ color: 'red' }}>*</span>
          </span>
        ),
    renderValue: 'Location',
    renderType: 'AutoComplete',
  },
  {
    id: 'Size',
    label: 'Size',
    renderValue: 'size',
    renderType: 'Text',
  },
  {
    id: 'Brands',
    label: 'Brands',
    renderValue: 'brands',
    renderType: 'AutoComplete',
  },

  {
    id: 'Weeks_From_Launch',
    label: 'Weeks From Launch',
    renderValue: 'weeksFromLaunch',
    renderType: 'Text',
  },
  {
    id: 'quantity',
    label: 'Quantity',
    renderValue: 'quantity',
    renderType: 'Text',
  },

  {
    id: 'Submit',
    label: 'Submit',
    renderValue: 'Submit',
    renderType: 'Button',
  },
]
export const aogTabLabels = [
  { label: 'Auto Order Grid', value: 'aog' },
  { label: 'Auto Order Grid SubClass', value: 'aogsubclass' },
]
export const RenderSelectionFields = [
  {
    id: 'Department',
    label: (
      <span>
        Department<span style={{ color: 'red' }}>*</span>
      </span>
    ),
    renderValue: 'department',
    renderType: 'AutoComplete',
  },
  {
    id: 'Class',
    label: (
          <span>
            Class<span style={{ color: 'red' }}>*</span>
          </span>
        ),
    renderValue: 'class',
    renderType: 'AutoComplete',
  },
  {
    id: 'SubClass',
    label: 'Sub Class',
    renderValue: 'subclass',
    renderType: 'AutoComplete',
  },
]
export const locationList = [
  {
    label: 'Splashlight Studio',
    value: 'Splashlight Studio',
  },
  {
    label: 'Schawk Chicago',
    value: 'Schawk Chicago',
  },
  {
    label: 'Schawk Shanghai',
    value: 'Schawk Shanghai',
  },
  {
    label: 'Winter Street Samples Props and Workshop',
    value: 'Winter Street Samples Props and Workshop',
  },
  {
    label: 'Periscope Studio Hong Kong',
    value: 'Periscope Studio Hong Kong',
  },
  {
    label: 'Periscope Studio Bloomington',
    value: 'Periscope Studio Bloomington',
  },
  {
    label: 'Industrial Color',
    value: 'Industrial Color',
  },
  {
    label: 'TPS-5 - Shakira Tierney',
    value: 'TPS-5 - Shakira Tierney',
  },
]
